import React, { Component } from "react";
const hiddenFileInput = React.createRef(null);

class ModalReactivacionEstablecimiento extends Component {
  render() {
    return (
      <>
        <div>
          <fieldset className="panel">
            <legend> </legend>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label htmlFor="sancion">
                     Seleccione sanción para resolver:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="sanciones"
                      id="sanciones"
                      onChange={(e) =>
                        this.props.component.handleOnChangeSancionReactivacion(e)
                      }
                      value={this.props.state.sancion_bitacora_id}
                      className="form-control"
                    >
                      <option value="">Seleccione</option>
                      {this.props.state.sancion_bitacora.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.descripcion}
                        </option>
                      ))}
                      </select>
                      <label>Tipo infracción:</label>
                      <input
                      name="tipo_infraccion"
                      type="text"
                      disabled={true}
                      value={this.props.state.tipo_infraccion_bitacora}
                      className="form-control m-b-5"
                      placeholder ="Tipo infracción"
                    ></input>
                    <label>Causa de sanción:</label>
                    <textarea
                      name="causa_bitacora"
                      type="text"
                      disabled={true}
                      value={this.props.state.causa_bitacora}
                      className="form-control m-b-5"
                      rows="5"
                      placeholder = "Causa de sanción"
                    ></textarea>
                    <label>Causa de la reactivación:
                    <span className="text-danger">*</span>
                    </label>
                       <textarea
                      className="form-control"
                      placeholder="Causa de la reactivación"
                      maxLength={1000}
                      rows="5"
                      name="causa_reactivacion"
                      value={this.props.state.causa_reactivacion}
                      onChange={(e) =>
                        this.props.component.handleOnChangeCausaReactivacion(e)
                      }
                    ></textarea>
                  </div>
                </div>
                <div className="col-lg-10">
                  <div className="form-group">
                    <label htmlFor="documentp_1">
                      {" "}
                      <span className="text-danger">
                        {" "}
                        Solo se aceptan archivos .pdf *
                      </span>
                    </label>
                    <input
                      name="documento_reactivacion"
                      type="text"
                      disabled={true}
                      //defaultValue="Subir informe inspector"
                      value={this.props.state.nom_documento}
                      className="form-control m-b-5"
                      placeholder="Subir (caja o documento)"
                    ></input>
                  </div>
                </div>
                <div className="col-md-2" style={{ marginTop: "1.7%" }}>
                  <div className="form-group">
                    <button
                      type="button"
                      name="b_documento_reactivacion"
                      className="btn btn-primary float-right"
                      onClick={(e) => hiddenFileInput.current.click()}
                    >
                      Seleccionar archivo
                    </button>
                    <input
                      type="file"s
                      accept=".pdf"
                      ref={hiddenFileInput}
                      name="documento_reactivacion"
                      onChange={(e) => this.props.component.handleFile(2, e.target)}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <hr></hr>
          <div className="btn-group float-right">
            <button
              type="button"
              onClick={() => {
                this.props.component.closeModalSancionEstReac(1)
//                this.props.component.limpiarCampos(2, 0);
              }}
              className="btn btn-danger"
            >
              Regresar
            </button>
            <button
              type="button"
              onClick={() => {
                this.props.component.handleSubmit(2,2);
              }}
              className="btn btn-success"
            >
              Aceptar
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default ModalReactivacionEstablecimiento;